import { useEffect, useState } from 'react';
import { fetchTimeSpanKPI } from '../api/timeSpanApi';

/**
 * React hook to fetch the dataset time span KPI
 * @param {string|null} activeFile optional file type
 * @returns {{data: object|null, loading: boolean, error: string|null, refresh: Function}}
 */
export const useTimeSpan = (activeFile = null) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async (fileType) => {
    setLoading(true);
    setError(null);
    try {
      const effectiveFileType = fileType ?? activeFile ?? null;
      const kpi = await fetchTimeSpanKPI(effectiveFileType);
      setData(kpi);
    } catch (e) {
      setError(e?.message || 'Failed to load time span');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      setLoading(true);
      setError(null);
      try {
        const kpi = await fetchTimeSpanKPI(activeFile ?? null);
        if (!cancelled) setData(kpi);
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Failed to load time span');
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    run();
    return () => { cancelled = true; };
  }, [activeFile]);

  return { data, loading, error, refresh: load };
};
